'use client'
import { Button } from "primereact/button";
import { Dialog } from 'primereact/dialog';
import { companyName, doDownloadBrocher } from "@/_config";
import { ChartHomeAutomation } from "./chartGraph";

export const HomeAutomation = ({ setVisible, visible, doAction }) => {
    return (<Dialog
        maximized
        modal
        style={{ width: '50vw' }}
        header="Home Automation Setup Guide"
        breakpoints={{ '960px': '100vw', '641px': '100vw' }}
        visible={visible}
        onHide={() => { if (!visible) return; setVisible(false); }}>

        <div className='mt-3 mb-3 font-bold text-sm text-center flex flex-column align-items-center justify-content-center'>
            <div>
                <div className="ennix-logo-text flex justify-content-center align-items-center flex-column gap-2">
                    <div className="h-2rem w-2rem flex text-xl bg-white text-100 border-circle align-items-center justify-content-center text-center">E</div>
                    <div> <span className="text-2xl">{companyName}</span>
                        <div className="mt-1">offers smart devices that work seamlessly with Google Assistant, Alexa, Siri, and Matter.</div>
                    </div>
                </div>

                <div className="flex mt-5 mb-5  flex-row gap-3 justify-content-between align-items-center">

                    <div className="flex flex-column gap-2 justify-content-center align-items-center">
                        <Button onClick={() => doDownloadBrocher()} icon="pi pi-download" style={{ color: 'black' }} className="bg-white border-0 hover:opacity-80" rounded outlined aria-label="Filter" />
                        <span className="text-xs h-3rem">  Download Brochure </span>
                    </div>

                    {/* <div className="flex flex-column gap-2 justify-content-center align-items-center">
                    <Button icon="pi pi-video" style={{ color: 'black' }} className="bg-white border-0 hover:opacity-80" rounded outlined aria-label="Filter" />
                    <span className="text-xs h-3rem"> View Our AI <small> <br/>Home Automation Demo </small></span>
                </div> */}

                    <div className="flex flex-column gap-2 justify-content-center align-items-center hover:opacity-60">
                        <Button onClick={() => doAction('message')} icon="pi pi-envelope" style={{ color: 'black' }} className="bg-white border-0 " rounded outlined aria-label="Filter" />
                        <span className="text-xs h-3rem"> Send Enquiry ddd </span>
                    </div>

                </div>
            </div>
            <ChartHomeAutomation />
        </div>
    </Dialog>)
}

